import React, { useEffect, useState } from "react";
import useFetch from "hooks/useFetch";
import Loading from "components/Loading";
import { useParams, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./AddLinkedinProfileToFilter.scss";
import { useDispatch } from "react-redux";
import { displaySuccess } from "stores/flashmessages/flashMiddleware";

const AddLinkedinProfileToFilter = () => {
  const { id: filterId } = useParams();
  const history = useHistory();
  const { get, post, isLoading } = useFetch();
  const [profiles, setProfiles] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchProfiles = async () => {
      const data = await get("/admin/linkedin_profiles");
      if (data) setProfiles(data);
    };
    fetchProfiles();
  }, []);

  const toggleSelect = (profileId) => {
    setSelectedIds((prev) =>
      prev.includes(profileId)
        ? prev.filter((id) => id !== profileId)
        : [...prev, profileId]
    );
  };

  const handleSubmit = async () => {
    await post(
      "/admin/linkedin_profile_filters/batch_create",
      { filter_id: filterId, linkedin_profile_ids: selectedIds },
      () => history.push("/admin/profilefilters"),
      dispatch(displaySuccess(t("admin:profiles_added_to_filter_with_success")))
    );
  };

  return (
    <div className="container py-5">
      <h2 className="mb-4 text-center font-weight-bold text-dark">
        {t("admin:add_profiles_to_filter")}
      </h2>

      {isLoading ? (
        <div className="d-flex justify-content-center">
          <Loading />
        </div>
      ) : profiles.length === 0 ? (
        <div className="text-center my-5 text-muted">
          {t("admin:no_profiles_to_display")}
        </div>
      ) : (
        <div className="table-responsive-filter">
          <table className="table table-hover table-bordered table-striped rounded mb-0">
            <thead className="thead-dark">
              <tr>
                <th>{t("admin:first_name")}</th>
                <th>{t("admin:last_name")}</th>
                <th>{t("admin:job_title")}</th>
              </tr>
            </thead>
            <tbody>
              {profiles.map((profile) => {
                const isSelected = selectedIds.includes(profile.id);
                return (
                  <tr
                    key={profile.id}
                    onClick={() => toggleSelect(profile.id)}
                    style={{
                      backgroundColor: isSelected ? "#fff7df" : "#ffffff",
                      cursor: "pointer",
                      transition: "background-color 0.2s ease-in-out",
                    }}
                  >
                    <td className="align-middle">{profile.first_name}</td>
                    <td className="align-middle">{profile.last_name}</td>
                    <td className="align-middle">{profile.headline}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {profiles.length > 0 && (
        <div className="text-center mt-4">
          <button
            className="btn btn-warning font-weight-bold px-5 py-2"
            onClick={handleSubmit}
            disabled={selectedIds.length === 0}
          >
            {t("admin:add")} {selectedIds.length} {t("admin:profiles")}
            {selectedIds.length > 1 ? "s" : ""}
          </button>
        </div>
      )}
    </div>
  );
};

export default AddLinkedinProfileToFilter;
